module.exports = __webpack_public_path__ + "static/media/add-image.97f9d443.svg";